import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import { ClientAuthProvider } from '../context/ClientAuthContext';
import { useTenant } from '../context/TenantContext';
import ClientAuth from '../pages/ClientAuth';
import ClientPortalLayout from './clientPortal/ClientPortalLayout';
import ClientOverviewPage from '../pages/ClientOverviewPage';
import ClientBuyingPage from '../pages/ClientBuyingPage';
import ClientSellingPage from '../pages/ClientSellingPage';
import ClientResourcesPage from '../pages/ClientResourcesPage';

export function ClientArea() {
  const { slug } = useParams();
  return (
    <ClientAuthProvider agentSlug={slug}>
      <Routes>
        <Route path="auth" element={<ClientAuth />} />
        <Route element={<ClientPortalLayout />}>
          <Route index element={<ClientOverviewPage />} />
          <Route path="buying" element={<ClientBuyingPage />} />
          <Route path="selling" element={<ClientSellingPage />} />
          <Route path="resources" element={<ClientResourcesPage />} />
          {/* Old bookmarked links to /buyer and /seller keep working. */}
          <Route path="buyer" element={<Navigate to="../buying" replace />} />
          <Route path="seller" element={<Navigate to="../selling" replace />} />
        </Route>
      </Routes>
    </ClientAuthProvider>
  );
}

export function BuyerChatWithClientAuth({ children }) {
  const { slug } = useParams();
  const tenant = useTenant();
  if (tenant.loading && !slug) {
    return <div className="loading-screen"><div className="spinner" /></div>;
  }
  const fromSlug = slug ? String(slug).trim().toLowerCase() : '';
  const fromTenant = tenant.agent?.slug ? String(tenant.agent.slug).toLowerCase() : '';
  const normalized = fromSlug || fromTenant || (tenant.platform ? 'sarah-murphy' : '');
  if (!normalized) {
    return <Navigate to="/" replace />;
  }
  return (
    <ClientAuthProvider agentSlug={normalized}>
      {children}
    </ClientAuthProvider>
  );
}
